import './InfoModal.css';

import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const InfoModal = ({ children, isOpen, setOpen, options = {} }) => {
    const { t } = useTranslation();
    const { header = null, footer = null, closeBtnText = null, center = false } = options;

    return (
        <Modal show={isOpen} onHide={() => setOpen(false)}>
            {header && (
                <Modal.Header className={`${center && 'justify-content-center'}`}>
                    <Modal.Title>{options.header}</Modal.Title>
                </Modal.Header>
            )}
            <Modal.Body className={`${center && 'd-flex flex-column align-items-center'}`}>
                {children}
            </Modal.Body>
            <Modal.Footer>
                {footer && <div>{footer}</div>}
                <Button variant="secondary" onClick={() => setOpen(false)}>
                    {closeBtnText ? closeBtnText : t('close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default InfoModal;
